import mixpanel, { Callback, Dict } from 'mixpanel-browser';

import { EDITOR_VERSION } from './mixpanel.config';
import { MixpanelActions, MixpanelEvent } from './mixpanel.types';

// use a fake token when it's not available to prevent breaking the app
const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN ?? '123';
mixpanel.init(mixpanelToken, {
  record_sessions_percent: 0.5,
  record_mask_text_selector: '',
  record_block_selector: '',
  record_block_class: '',
});

// To use mixpanel, import { Mixpanel } from .. in any component and call mixpanel.<action/method name>
const actions: MixpanelActions = {
  identify: (id) => {
    mixpanel.identify(id);
  },
  alias: (id) => {
    mixpanel.alias(id);
  },
  track: (event: MixpanelEvent, props?) => {
    if (!event || !event.eventName) {
      console.error('Event name is required for tracking');
      return;
    }

    // don't track events in test environment
    if (import.meta.env.MODE === 'test') return;

    const eventName = event.eventName;
    if (!!props) {
      props.editor_version = EDITOR_VERSION;
      mixpanel.track(eventName, props);
    } else {
      mixpanel.track(eventName, { editor_version: EDITOR_VERSION });
    }
  },
  people: {
    set(prop: Dict | string, to?: any, callback?: Callback) {
      if (typeof prop === 'string' && !!to && !callback) {
        mixpanel.people.set(prop, to);
      } else if (typeof prop === 'string' && !!to && !!callback) {
        mixpanel.people.set(prop, to, callback);
      } else if (typeof prop !== 'string' && !callback) {
        mixpanel.people.set(prop);
      } else if (typeof prop !== 'string' && !!callback) {
        mixpanel.people.set(prop, callback);
      }
    },
  },
  start_session_recording: () => {
    mixpanel.start_session_recording();
  },
  stop_session_recording: () => {
    mixpanel.stop_session_recording();
  },
};

// Expose mixpanel to window so it can be used by third-party libraries (i.e. Chameleon)
window.mixpanel = mixpanel;

export const Mixpanel = actions;
